import { render } from "./TextEditorCmp.vue?vue&type=template&id=6b3aa32a"
import script from "./TextEditorCmp.vue?vue&type=script&lang=js"
export * from "./TextEditorCmp.vue?vue&type=script&lang=js"

import "./TextEditorCmp.vue?vue&type=style&index=0&id=6b3aa32a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__